// src/config/hazardVisibility.js
export const HAZARD_VISIBILITY = {
  Routine: false,
  Flooding: true,
  Hurricane: true,
  "Severe Storms": true,
  Tornado: true,
  Wildfire: true,
  "Winter Weather": true,
  "Extreme Heat": true,
  "Extreme Cold": true,
  "High Winds": true,
  "Dense Fog": false,
  "Surf & Rip Currents": false,
  "Drought":true,
  // Freeze:true
};
